__turbopack_context__.v({
  "root": "alerts-slides-module-scss-module__1MsQxG__root",
  "slide": "alerts-slides-module-scss-module__1MsQxG__slide",
  "visible": "alerts-slides-module-scss-module__1MsQxG__visible",
});
